import "./Technology.css";
import React, { useEffect, useRef, useState } from "react";
import { ArrowRightOutlined } from "@ant-design/icons";
import useIntersection from "../useIntersection";

const technologies = [
  {
    image: "assets/section-4--grid-1.png",
    title: "Artificial Intelligence",
    koreanTitle: "인공지능",
    description:
      "고도의 AI 기반 알고리즘을 통해 최첨단 거래 전략을 개발합니다.",
  },
  {
    image: "assets/section-4--grid-img-2.png",
    title: "Market Opportunity",
    koreanTitle: "시장 기회 탐지",
    description: "최신 시장 동향과 기회를 자동으로 탐지합니다.",
  },
  {
    image: "assets/product/etfport_logo2.png",
    title: "EMP Shannon",
    koreanTitle: "AI 자산분배",
    description:
      "고객 투자 유니버스와 시장 상황을 동시에 고려하여 높은 수익률과 안정성을 함께 추구하는 포트폴리오를 구성합니다.",
    detailUrl: "/emp",
  },
];

function Technology(props) {
  const sectionRef = useRef(null);
  const sectionInViewport = useIntersection(sectionRef, "0px");
  const [showSection, setShowSection] = useState(false);

  useEffect(() => {
    if (sectionInViewport) {
      setShowSection(true);
    }
  }, [sectionInViewport]);

  return (
    <div className="technology_root" ref={props.refProp}>
      <section
        className={`technology_section${
          showSection ? " technology_section_show" : ""
        }`}
        ref={sectionRef}
      >
        <div className="technology_inner">
          <header className="technology_header">
            <h2>Technology</h2>
          </header>

          <div className="technology_grid">
            {technologies.map((technology) => (
              <article
                className={`technology_item${
                  technology.detailUrl ? " technology_item_emp" : ""
                }`}
                key={technology.title}
              >
                <div className="technology_icon">
                  <img src={technology.image} alt={technology.title} />
                </div>
                <h3>{technology.title}</h3>
                <strong>{technology.koreanTitle}</strong>
                <p>{technology.description}</p>
                {technology.detailUrl && (
                  <a
                    href={technology.detailUrl}
                    target="_blank"
                    rel="noreferrer"
                  >
                    상세 보기
                    <ArrowRightOutlined aria-hidden="true" />
                  </a>
                )}
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Technology;
